import { isArray, isUndefined } from 'lodash-es'
import {
  ReactNode,
  Children,
  isValidElement,
  Fragment,
  ReactElement,
  ReactPortal,
} from 'react'

type Child = ReactPortal | ReactElement

type Slots = {
  [key: string]: ReactNode
}

export const createSlot = (children: ReactNode, slots: string[]) => {
  const slotMap: Slots = {}

  const hasSlot = (slot: string) => !isUndefined(slotMap[slot])

  const isFragment = (child: Child): child is ReactElement =>
    child.type === Fragment

  const addSlot = (child: ReactNode) => {
    if (!isValidElement(child)) return

    const fragmentProps = child.props as {
      children?: ReactNode
      name?: string
    }

    if (isFragment(child)) {
      const fragmentChildren = fragmentProps.children

      if (isArray(fragmentChildren)) {
        fragmentChildren.forEach((subChild: Child) => {
          addSlot(subChild)
        })
      } else {
        addSlot(fragmentChildren)
      }

      return
    }

    const slotName = fragmentProps.name
    if (slotName && slots.includes(slotName)) {
      slotMap[slotName] = fragmentProps.children
    }
  }

  Children.forEach(children, child => {
    addSlot(child)
  })

  return { slots: slotMap, hasSlot }
}
